import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { PublicRoomSystem } from "@classview/shared-types";

type RoomSystemsListProps = {
  roomSystems: PublicRoomSystem[];
};

/**
 * Displays a list of room systems in the session single view.
 * This is NOT an edit/form component.
 */
export function RoomSystemsList(props: RoomSystemsListProps) {
  const { roomSystems } = props;

  return (
    <ScrollArea
      type="always"
      className={cn("rounded-md border border-border", {
        "h-[427px]": roomSystems.length > 7, // 7 items * 61px = 427px
      })}
    >
      <div className="divide-y divide-border">
        {roomSystems.map((roomSystem) => (
          <div
            key={roomSystem.id}
            className="flex items-center justify-between px-4 py-2"
          >
            <div className="flex min-w-0 items-center">
              <div className="ml-2 min-w-0">
                <p className="text-foreground">{roomSystem.name}</p>
                <p className="text-sm text-muted-foreground">
                  {roomSystem.organisation.name}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
